import React from "react";

const Bash_Cp = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Cp</h2>
      <p>Copy files and directories.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>cp [options] source dest</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>cp file.txt /tmp/
cp -r folder/ /backup/folder/</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use -i to prompt before overwrite.</p>
    </div>
  );
};

export default Bash_Cp;
